import { queryIndustryCompany } from '@/services/company';

export default {
  namespace: 'ChainBrandStoreIndustryCompanies',
  state: {
    data: {},
  },
  effects: {
    *queryIndustryCompany({ payload }, { call, put }) {
      const { status, data } = yield call(queryIndustryCompany, payload);

      if (status === 200) {
        yield put({
          type: 'save',
          payload: {
            list: data.data.items,
            pagination: {
              total: data.data.meta.total,
              pageSize: data.data.meta.per_page,
              current: data.data.meta.current_page,
            },
          },
        });
      }
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        data: payload,
      };
    },
  },
};
